import { render } from "./SeparationTermination.vue?vue&type=template&id=15158d96&scoped=true"
import script from "./SeparationTermination.vue?vue&type=script&lang=js"
export * from "./SeparationTermination.vue?vue&type=script&lang=js"

import "@/assets/css/hr-page-shared.css?vue&type=style&index=0&lang=css&external"
import "./SeparationTermination.vue?vue&type=style&index=1&id=15158d96&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15158d96"]])

export default __exports__